import { inject, Injectable, Renderer2, RendererFactory2 } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class MaterialSeoService {
    public rendererFactory = inject(RendererFactory2);

    private readonly renderer: Renderer2 = this.rendererFactory.createRenderer(null, null);

    public generateStructuredData(data: any): void {
        const script = this.renderer.createElement('script');
        this.renderer.setAttribute(script, 'type', 'application/ld+json');
        this.renderer.appendChild(script, this.renderer.createText(JSON.stringify(data)));
        this.renderer.appendChild(document.head, script);
    }
}
